export default __webpack_public_path__ + "1fc4af9f2a776ec0e50c82dd4a02d53a.svg";